
import React, { Component, useState, useEffect, useContext } from "react";
import { Cookies } from '../../../index.js';
import { useNavigate, Link, useLocation } from "react-router-dom";
import StatusBadge from "../../../js/buttonstatus.jsx";
import AdSense from 'react-adsense';
import { alert_error, alert_success } from '../../../AppContext';
import axios from "axios";
import queryString from 'query-string';
import { FaEdit } from 'react-icons/fa';
import Select from "react-select";
import ToggleButton from '../../../app_structure/toggleButton.jsx';
import { ClipLoader, PulseLoader } from 'react-spinners';
const Nhatkylink = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [chedo, setchedo] = useState('');
  const [note, setnote] = useState('');
  const [newbie_buff, set_newbie_buff] = useState('YES');
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const [isDisabled, setIsDisabled] = useState(false);
  const [amount, setamount] = useState(false);
  const [idlink, setidlink] = useState(false);
  const [showedit, setshowedit] = useState(false);
  const [inputlienket, setinputlienket] = useState('');
  const [service, setservice] = useState('');
  const [buttonloadlist, setbuttonloadlist] = useState(true);
  const currentPath = window.location.pathname;
  const parts = currentPath.split('/');
  const duongdan = parts[parts.length - 1];
  const totalPages = 5; // tổng số trang
  const values = queryString.parse(window.location.search);
  const currentPagephu = values.listtrang
  const [currentPage, setcurrentPage] = useState(1);
  const [pageNumbers, setpageNumbers] = useState(Array.from({ length: totalPages }, (_, i) => i + 1));

  const [options, setoptions] = useState([
    {
      id: '', stt: '', name: 'Đang tải danh sách',
      money: '', status: 'show', content: '', servicecode: ''
    }
  ]);
  function laydulieu() {
    axios
      .post('https://hust.media/link/load_users/service4.php', {
        category: 'urlshorten'
      })
      .then(response => gopdulieu(response))
      .catch(error => console.log(error))
  }
  function gopdulieu(response) {
    const arr1 = [
      {
        id: '', stt: '', name: 'Chọn 1 cấp độ kiếm tiền',
        money: '', status: 'show', content: '', servicecode: ''
      }
    ];

    const arr2 = response.data;
    // console.log(arr1.concat(arr2));
    setoptions(arr1.concat(arr2));

  }
  const [dulieudonhang, setdulieudonhang] = useState([
    {
      id: 1,
      view: 100,
      verified: 50,
      service_name: "Đang tải danh sách vui lòng đợi",
      url: "Đang tải danh sách vui lòng đợi",
      capdo: 10,
      status: 'show',
      note: "Note 1",
      updatedate: "2023-04-05",
    }
  ]);
  const laynhatky = async () => {
    const myCookieValue = Cookies.get('apikey');
    const values = queryString.parse(window.location.search);
    const listtrang = values.listtrang || 1;

    setcurrentPage(values.listtrang);
    // alert(values.listtrang);
    try {
      const response = await axios.get('https://hust.media/link/load_users/history_create.php?apikey=' + myCookieValue + '&listtrang=' + listtrang);
      if (response.data != '') {
        setbuttonloadlist(false);
        setdulieudonhang(response.data);
      }
    } catch (error) {

    }
  };
  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  const handleOptionChange = (selectedOption) => {
    setIsOpen(false);
    if (selectedOption) {
      const selectedValue = selectedOption.value;
      setchedo(selectedValue);
      const selectedOptionOk = options.find((option) => option.servicecode === selectedValue);
      console.log(selectedOptionOk);
      setservice(selectedOptionOk);
      // Add other actions here based on the user's selection
    }
  };
  const handleFocus = () => {
    setIsOpen(true);
    console.log(123);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  const handleMenuOpen = () => {
    setIsOpen(true);
  };
  const editlevel = (value) => {
    setIsOpen(true);
    setshowedit(true);
    setidlink(value);
    window.scrollTo(0, 0);
    const selectedOptionOk = dulieudonhang.find((option) => option.id === value);
    console.log(selectedOptionOk);
    setinputlienket(selectedOptionOk.url);
    setnote(selectedOptionOk.note);
    if (selectedOptionOk.capdo == 8) {
      setamount(selectedOptionOk.money);
    }
    else {
      setamount('');
    }
  };
  const exitedit = () => {
    setshowedit(false);
  };
  useEffect(() => {
    laynhatky();
    laydulieu();
  }, []);
  function handleSubmit(event) {
    setnutxuly(0);
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!idlink) {
      alert('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    if (chedo == 8) {
      call_api('NO');
    } else {
      call_api(newbie_buff);
    }
  };
  function call_api(value) {
    const apikey = Cookies.get('apikey');
    axios
      .post('https://hust.media/link/edit.php', {
        idlink: idlink,
        apikey: apikey,
        chedo: chedo,
        inputlienket: inputlienket,
        note: note,
        money: amount,
        newbie_buff: value
      })
      .then(
        response => (testFunction(response))
      )
      .catch(error => console.log(error))
  }
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
      laynhatky();
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  const location = useLocation();
  useEffect(() => {
    setbuttonloadlist(true);
    // Xử lý sự kiện khi location thay đổi, ví dụ:
    console.log('Đã thay đổi đường dẫn:', location.pathname);
    laynhatky();
  }, [location]);
  const navigate = useNavigate();
  function switch_router(link) {
    navigate(link);
  };
  function handleToggle(isOn) {
    if (isOn) {
      set_newbie_buff('YES');
    } else {
      set_newbie_buff('NO');
    }
  }
  return (
    <>
      <div className="mt-1 mb-1 max-h-16">
        <div className="cards">
          <AdSense.Google
            client="ca-pub-4574266110812955"
            slot="1627514116"
            style={{ display: 'block' }}
            format='horizontal'
            responsive='false'
          /></div>
      </div>
      {
        showedit &&
        (<>
          <form onSubmit={(e) => e.preventDefault()} className="mx-2 mb-1 add-form">
            <div className="form-control">
              <div className='flex items-center justify-between flex-1'>
                <label className="mb-2 text-lg">Chỉnh sửa link {idlink} </label>
                <label onClick={exitedit} className="mb-2 px-2 ">Đóng</label>
              </div>
              <Select
                classNamePrefix="Chọn 1 lựa chọn"
                onFocus={handleFocus}
                options={options.map((option) => ({
                  value: option.servicecode,
                  label: `${option.name}`,
                }))}
                menuIsOpen={isOpen}
                isDisabled={isDisabled}
                onBlur={handleBlur}
                onMenuOpen={handleMenuOpen}
                onChange={handleOptionChange}
                isLoading={false}
                isClearable={true}
                isRtl={false}
                isSearchable={false}
              />
              <label>Sửa liên kết</label>
              <div className="input-group flex-nowrap">
                <span className="input-group-text" id="addon-wrapping">
                  url
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Có thể bỏ trống"
                  aria-label="inputlienket"
                  value={inputlienket}
                  name="inputlienket"
                  aria-describedby="addon-wrapping"
                  onChange={e => setinputlienket(e.target.value)}
                />
              </div>
              <label>Sửa mô tả</label>
              <div className="input-group flex-nowrap">
                <span className="input-group-text" id="addon-wrapping">
                  note
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Có thể bỏ trống"
                  aria-label="inputlienket"
                  value={note}
                  name="inputlienket"
                  aria-describedby="addon-wrapping"
                  onChange={e => setnote(e.target.value)}
                />
              </div>
              {chedo == 8 ? (<>
                <label className="mt-0 mb-0 flex justify-center items-center">Giá mua link</label>
                <div className="input-group flex-nowrap">
                  <input
                    onChange={(e) => {
                      setamount(e.target.value);
                    }}
                    value={amount}
                    type="number"
                    className="form-control mb-0"
                    placeholder="Nhập số lượng mong muốn"
                    aria-label="inputcaption"
                    name="inputcaption"
                    aria-describedby="addon-wrapping"
                  ></input>
                </div>
                <div className="text-xs mt-[-2px] ">
                  Tối thiểu {service.minorder} &emsp; Tối đa {service.maxorder}
                </div>
              </>) : (<>
                <div className="flex items-center space-x-2">
                  <div className="bg-gray-200 px-2 py-1 rounded-md">buff views</div>
                  <div className="flex items-center border-r border-t border-b py-1 border-gray-300 pr-2">
                    <ToggleButton
                      onToggle={handleToggle} newbie_buff={newbie_buff}
                    />
                    <span className="ml-2">ưu đãi người mới giúp links nhiều views</span>
                  </div>
                </div>
              </>)}
              <button disabled={nutxuly == 1} onClick={handleSubmit}
                className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                <div className='flex items-center justify-between flex-1'>
                  {nutxuly == 1 &&
                    <div className="spinner-border" role="status">

                    </div>}


                  <span className='text-lg font-medium text-white'>
                    {nutorder} </span>
                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                </div>
              </button>
            </div>
          </form>
        </>)
      }
      <div className="row fixrow">
        <div className="text-center">
          <button className="mx-2 btn btn-primary"
            onClick={() => switch_router('/shop/creative/create')}>
            Thêm link mới
          </button>
        </div>
      </div>
      <div className="mt-2" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <nav>
          <ul className="pagination">
            {pageNumbers.map((pageNumber) => (
              <li key={pageNumber} className={`page-item ${pageNumber == currentPage ? 'active' : ''}`}>
                <Link to={`/shop/creative/${duongdan}?listtrang=${pageNumber}&app=showadview`} className="page-link">
                  {pageNumber}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      {dulieudonhang === 'empty' && !buttonloadlist ? (

        <>
          <div className="table-responsive overflow-x-hidden">
            <div className="text-center text-2xl mt-3">
              📦 Danh sách đơn hàng trống rỗng, chưa có thông tin nào 📭
            </div>
          </div>
        </>
      ) : (
        buttonloadlist ? (
          <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
            <ClipLoader color="#fff" size={150} />
          </div>
        ) : (
          <div className="mx-2 table-responsive overflow-x-hidden">
            <table className="table align-middle table-flush table-sm table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className="text-lowercase text-center" style={{ width: "10%" }} scope="row">
                    mã đơn hàng
                  </th>
                  <th className="text-center" style={{ width: "14%" }} scope="row">
                    Cấp độ
                  </th>
                  <th className="text-lowercase text-center" style={{ width: "14%" }} scope="col">
                    link
                  </th>
                  <th className="text-center" style={{ width: "9%" }} scope="row">
                    Mô tả
                  </th>
                  <th className="text-center" style={{ width: "7%" }} scope="col">
                    THỜI GIAN
                  </th>
                </tr>
              </thead>
              <tbody>
                {dulieudonhang.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">
                      <p onClick={() => saochep(item.id)} className="text-sm">{item.id}</p>
                      Views
                      <br />
                      {item.view}
                      <br />
                      Views vượt link
                      <br />
                      <span className="badge badge-default">
                        <b className="text-black">{item.verified}</b>
                      </span>
                    </td>
                    <td className="text-center ">
                      <div onClick={() => editlevel(item.id)} className="flex items-center justify-center"> {/* Thêm lớp justify-center để căn giữa chiều ngang */}
                        <div className="text-xs bg-pink-500 text-white rounded-3xl px-1 py-1">
                          <div className="text-white text-wrap font-bold text-sm">{item.service_name}</div>
                        </div>
                        <div className="ml-1 text-center">
                          <FaEdit size={19} />
                        </div>
                      </div>


                      <div>  mô tả </div>
                      <div className="text-base text-lowercase text-black break-all leading-snug text-wrap">
                        {item.note}
                      </div>
                    </td>
                    <td className="text-center">
                      <div onClick={() => saochep(item.code)} style={{ width: "100%" }} className="mb-2  break-all  text-lowercase bg-danger badge rounded-pill text-wrap">
                        {item.code}
                      </div> <br />
                      <div onClick={() => saochep(item.url)} style={{ width: "100%" }} className="mb-2 break-all  text-lowercase bg-danger badge rounded-pill text-wrap">
                        {item.url}
                      </div>
                    </td>
                    <td className="text-center">

                      <div style={{ color: "red" }}>{item.capdo}</div>
                      <div style={{ width: "100%" }} className="text-lowercase text-wrap">
                        <StatusBadge status={item.status}/>
                      </div>
                      {item.money && item.money != 0 && (<>
                        <div className="text-wrap">
                          Giá mua link: {item.money} Coins
                        </div>
                      </>)}
                    </td>
                    <td className="text-center">
                      <div style={{ width: "100%" }} className="text-lowercase text-wrap">

                        <div className="text-lowercase text-wrap" ><br /> {item.createdate}</div>
                        {item.updatedate}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
    </>
  );
};

export default Nhatkylink;
